const createQuery = () => `
... on ArticleDownloadWidget {
  id
}
`
export default createQuery
